require('../js/scripts.js')